module.exports = __webpack_public_path__ + "img/image_23.4adcf1ec.png";